module.exports = __webpack_public_path__ + "static/media/image-5-1024x618.a3ecdbe7.png";